import React from 'react'
import { useDispatch } from 'react-redux'
import { closeModal } from '@/components/composed/Modal/actions'
import { Button, GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import type { IFinancingCallbackStatusWrapperProps } from './types'
import './styles.scss'

export const FinancingCallbackStatusWrapper = (props: IFinancingCallbackStatusWrapperProps) => {
  const { icon, title, subtitle } = props

  const dispatch = useDispatch()
  const closeCallbackModal = () => dispatch(closeModal())

  return (
    <div className="financingCallbackStatusWrapper">
      <GlassMorphIcon className="financingCallbackStatusWrapper__icon" image={icon} />

      <h4 className="financingCallbackStatusWrapper__title">{title}</h4>
      {subtitle && <div className="financingCallbackStatusWrapper__subtitle">{subtitle}</div>}

      <Button className="financingCallbackStatusWrapper__action" modifiers={['green', 'full-width-always']} onClick={closeCallbackModal}>
        {messages.action}
      </Button>
    </div>
  )
}
